import * as Yup from 'yup'

import { sanitizeField } from './form'
import { TForm } from './types'

const RULES = {
  name: Yup.string().required('O campo nome é obrigatório.'),
  phone_number: Yup.string()
    .required('O campo telefone é obrigatório.')
    .test(
      'phone',
      'O número de telefone deve ter no mínimo 11 digítos.',
      v => v?.replace(/[^0-9]/g, '').toString().length === 11,
    ),
  email: Yup.string()
    .required('O campo email é obrigatório.')
    .email('O email informado é inválido.'),
  birthdate: Yup.string()
    .required('O campo data de nascimento é obrigatório.')
    .test(
      'date',
      'A data informada não segue o padrão DD/MM/AAAA',
      v =>
        !!sanitizeField({ type: 'date', value: v })?.match(
          /^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/,
        ),
    ),
  gender: Yup.string().required('O campo gênero é obrigatório.'),
  password: Yup.string()
    .required('O campo senha é obrigatório.')
    .min(6, 'A senha deve ter no mínimo 6 caracteres.'),
  password_confirmation: Yup.string().oneOf(
    [Yup.ref('password')],
    'As senhas não coincidem.',
  ),
  code: Yup.string().required('O campo código de confirmação é obrigatório.'),
}

/**
 * @function form
 *
 * @param rules
 */
const formRules = (rules: TForm): Record<any, any> =>
  rules
    .map(rule => ({ [rule]: RULES[rule] }))
    .reduce((a, b) => Object.assign(a, b))

export { formRules }
